export default import.meta.ROLLUP_FILE_URL_0Vo7Ul8FCpTl02ZfNJfcAg